
import { Card, Grid, MenuItem } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import MDInput from "components/MDInput";
import RenderCustomField from "./RenderCustomField";
import { handleErrors } from "common";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import configurations from "config";
import axios from "axios";

const CustomFields = (props) => {
    const { dataFrom, customFields, control, errors, categoryCustomFields, categories, selectedCustomMultiselect,
        register, setValue, setError, productId, setSelectedCustomMultiselect, setCategoryCustomFields,
        setCustomFields, setIsLoading } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;

    const handleCategoryChange = (event) => {
        const selectedCategoryId = event.target.value;
        setValue('categoryId', selectedCategoryId);
        if (selectedCategoryId > 0) {
            setIsLoading(true)
            axios.get(baseUrl + '/product/getCategoryCustomFields/' + selectedCategoryId + '/' + productId + "/" + dataFrom, {
                headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
            }).then((response) => {
                setIsLoading(false)
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        setCategoryCustomFields(response.data.data.categoryCustomFields);
                    }
                    else {
                        if (message != '')
                            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
                }
            })
                .catch(error => {
                    setIsLoading(false)
                    handleErrors(error, t, navigate);
                });
        }
        else
            setCategoryCustomFields([])
    };

    return (
        <Card >
            <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        <MDTypography variant="h6" className="uppercaseLetters" >{t('customFields')}</MDTypography>
                        <MDTypography component="span" variant="body2"  >{t('customFieldsDetailsLabel', { dataFrom: dataFrom })}</MDTypography>
                    </Grid>
                    <Grid item xs={12} lg={12} sm={12} md={12}>
                        {customFields && customFields.map((item) => <RenderCustomField key={item.id}
                            dataFrom={dataFrom}
                            item={item}
                            from="general"
                            selectedCustomMultiselect={selectedCustomMultiselect}
                            errors={errors}
                            register={register}
                            control={control}
                            setValue={setValue}
                            setError={setError}
                            t={t}
                            productId={productId}
                            setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                            setCategoryCustomFields={setCategoryCustomFields}
                            customFields={customFields}
                            setCustomFields={setCustomFields}
                            categoryCustomFields={categoryCustomFields}
                            setIsLoading={setIsLoading}
                        />)}

                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">{t('categories')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                        </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                        <Controller
                            name="categoryId"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: t('categoriesRequired')
                                },
                                validate: (value) => {
                                    if (value === 0) {
                                        return t('categoriesRequired');
                                    }
                                    return true;
                                },
                            }}
                            defaultValue={0}
                            render={({ field }) => (
                                <MDInput
                                    select
                                    {...field}
                                    fullWidth
                                    onChange={handleCategoryChange}
                                    InputProps={{
                                        classes: { root: "select-input-styles " },
                                    }}
                                >
                                    <MenuItem key={0} value={0} >{t('selectCategory')}</MenuItem>
                                    {categories.map((category) => (
                                        <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </MDInput>
                            )}
                        />
                        {errors.categoryId && (<span className="errorMsg FloatRight">{errors.categoryId.message}</span>)}
                    </Grid>
                    <Grid item xs={12} lg={12} sm={12} md={12}>
                        {categoryCustomFields && categoryCustomFields.map((item) => <RenderCustomField key={item.id}
                            dataFrom={dataFrom}
                            item={item}
                            from="catagory"
                            selectedCustomMultiselect={selectedCustomMultiselect}
                            errors={errors}
                            register={register}
                            control={control}
                            setValue={setValue}
                            setError={setError}
                            t={t}
                            productId={productId}
                            setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                            setCategoryCustomFields={setCategoryCustomFields}
                            customFields={customFields}
                            setCustomFields={setCustomFields}
                            categoryCustomFields={categoryCustomFields}
                            setIsLoading={setIsLoading}
                        />)}
                    </Grid>
                </Grid>
            </Grid>
        </Card>)
}
export default CustomFields;
